'use client';

import React, { useCallback } from 'react';
import { Solicitud } from '@/types/solicitud';
import SolicitudManagement from './SolicitudManagement';
import { solicitudService } from '@/lib/api/solicitudService';
import { useAuth } from '@/hooks/useAuth';
import { Badge } from '@/components/ui/Badge';

const AutorizacionDGManagement: React.FC = () => {
  const { user } = useAuth();
  const authSub = user?.sub ?? null;

  const customFetch = useCallback(
    async (setSolicitudes: (s: Solicitud[]) => void) => {
      if (!authSub) return;
      const response = await solicitudService.getAutorizacionDG(authSub);
      setSolicitudes(response.data || []);
    },
    [authSub]
  );

  return (
    <SolicitudManagement
      title="Autorización Dirección General"
      customFetch={customFetch}
      modulo="autorizacion-dg"
      showNewButton={false}
      montoColumn="autorizado"
      renderActions={(s) => (
        <div className="flex items-center gap-2 flex-wrap">
          {s.fechaPropuesta && (
            <Badge variant="info" className="text-xs">
              Aut. Riesgos: {new Date(s.fechaPropuesta).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit' })}
            </Badge>
          )}
        </div>
      )}
    />
  );
};

export default AutorizacionDGManagement;
